import React from 'react';
import { BaseButton, BaseLabel } from './default-button.styles';
import Loading from '../components/loading/Loading';
import { CONTAINED_BUTTON_TEST_ID } from './default-button.constants';
import { ButtonColors, ButtonSize, ButtonVariant } from './default-button.type';

interface DefaultButtonProps {
    color: ButtonColors;
    size: ButtonSize;
    label: string;
    onClick: Function;
    isLoading: boolean;
    disabled: boolean;
    dataTestId: string;
    variant: ButtonVariant;
}

export const DefaultButton = ({
    color,
    size,
    label,
    onClick,
    isLoading,
    disabled,
    dataTestId,
    variant,
    ...props
}:DefaultButtonProps) => (
    <>
        <BaseButton
            color={color}
            size={size}
            onClick={onClick}
            disabled={disabled}
            data-testid={dataTestId}
            variant={variant}
            {...props}
        >
            {isLoading && <Loading backgroundColor="#ffffff" height="100%" />}
            {!isLoading && <BaseLabel>{label}</BaseLabel>}
        </BaseButton>
    </>
);

DefaultButton.defaultProps = {
    color: ButtonColors.DEFAULT,
    size: ButtonSize.LARGE,
    isLoading: false,
    disabled: false,
    dataTestId: CONTAINED_BUTTON_TEST_ID,
};
